<div class="m-nouveautes">
  <header class="m-nouveautes__header">
    <div class="m-nouveautes__headerContent">
      <div class="m-nouveautes__headerText">
        <h2 class="m-nouveautes__title">{{ 'NOUVEAUTES.TITLE' | translate }}</h2>
        <p class="m-nouveautes__subtitle">{{ 'NOUVEAUTES.SUBTITLE' | translate }}</p>
      </div>
      <button type="button" class="m-nouveautes__addBtn" (click)="onAddNouveaute()">
        + {{ 'NOUVEAUTES.ADD_NEW' | translate }}
      </button>
    </div>
  </header>

  <div class="m-nouveautes__content">
    <app-nouveautes-table [nouveautes]="nouveautes()" (rowClick)="onRowClick($event)" />
  </div>

  @if (showModal()) {
    <app-nouveaute-form-modal (closed)="onModalClose()" (submitted)="onModalSubmit($event)" />
  }

  @if (showEditModal()) {
    <app-nouveaute-form-modal
      [editData]="selectedNouveaute()"
      (closed)="onEditModalClose()"
      (submitted)="onEditSubmit($event)"
      (deleted)="onDelete($event)"
    />
  }

  <app-delete-confirmation-modal
    [isOpen]="showDeleteModal()"
    [title]="'COMMON.DELETE_MODAL.TITLE' | translate"
    [message]="'COMMON.DELETE_MODAL.MESSAGE' | translate"
    [itemName]="nouveauteToDelete()?.title"
    [confirmLabel]="'COMMON.DELETE_MODAL.CONFIRM' | translate"
    [cancelLabel]="'COMMON.DELETE_MODAL.CANCEL' | translate"
    [deletingLabel]="'COMMON.DELETE_MODAL.DELETING' | translate"
    [isDeleting]="false"
    (confirmed)="onConfirmDelete()"
    (cancelled)="onCancelDelete()"
  />
</div>
